import { useEffect } from 'react'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import {
  useHasFeature,
  useOrganizationEntitlements,
} from '@workspace/react-query'
import { Skeleton } from '@workspace/ui/components/skeleton'
import { authClient } from '@/lib/auth'
import { requireActiveSubscription } from '@/lib/middleware'
import { useTopNav } from '@/context/top-nav-provider'
import { Main } from '@/components/layout/main'
import { SetupKitPage } from '@/features/houses/setup/setup-kit-page'

export const Route = createFileRoute(
  '/_authenticated/_organization/houses/setup-kit'
)({
  beforeLoad: async () => requireActiveSubscription(),
  component: SetupKitRoute,
})

/** The organisation's setup kit: not one house's page, so it has its own band and crumbs. */
function SetupKitRoute() {
  const { data: organization } = authClient.useActiveOrganization()
  const organizationId = organization?.id ?? ''
  const { setLinks } = useTopNav()
  const entitlements = useOrganizationEntitlements(organizationId)
  const hasInventory = useHasFeature(organizationId, 'sil.inventory')

  useEffect(() => {
    setLinks([
      { title: 'Houses', href: '/houses' },
      { title: 'Setup kit', href: '/houses/setup-kit', isActive: true },
    ])
    return () => setLinks([])
  }, [setLinks])

  let body
  if (!organizationId || entitlements.isPending) {
    body = <Skeleton role='status' aria-label='Loading' className='h-64' />
  } else if (!hasInventory) {
    // The kit is behind the pilot key: without it the Houses page is the way back.
    body = <Navigate to='/houses' replace />
  } else {
    body = <SetupKitPage />
  }
  return <Main fluid>{body}</Main>
}
